<template>
  <span class="cursor-pointer" v-if="usersTagged.length > 0">
    <span class="text-400-default"> cùng với </span>
    <span class="cursor-pointer text-400-semibold hover-link userPopoverName" @click="$router.push(getProfileLink(usersTagged[0].id))"
          v-on:mouseleave="onMouseleave($event)" v-on:mouseover="onMouseover($event, usersTagged[0])">{{usersTagged[0].fullname}}</span>
    <leadership-badge-icon :user="usersTagged[0]" />
    <span v-if="usersTagged[1]" >
      <span class="text-400-default">, </span>
      <span class="cursor-pointer text-400-semibold hover-link userPopoverName" @click="$router.push(getProfileLink(usersTagged[1].id))"
            v-on:mouseleave="onMouseleave($event)" v-on:mouseover="onMouseover($event, usersTagged[1])">{{usersTagged[1].fullname}}</span>
      <leadership-badge-icon :user="usersTagged[1]" />
    </span>
    <span v-if="usersTagged.length > 2">
      <span class="text-400-default"> và </span>
      <span class="cursor-pointer text-400-semibold" v-on:mousemove="showOtherUserTagged($event)" v-on:mouseleave="hideOtherUserTagged">{{usersTagged.length - 2}} người khác</span>
    </span>
  </span>
</template>

<script>
import $ from "jquery";
import LeadershipBadgeIcon from "../../../components/LeadershipBadgeIcon.vue";
export default {
  name: "TagUserView",
  components: { LeadershipBadgeIcon },
  props: {
    usersTagged: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onMouseover(e, userInfo) {
      this.$emit('mouseover-user-tagged', {
        event: e,
        user: userInfo,
      });
    },
    onMouseleave(e) {
      this.$emit('mouseleave-user-tagged', e);
    },
    showOtherUserTagged(e) {
      let leftCss = e.target.offsetLeft;
      let topCss = 35 + e.target.offsetTop;
      $('.tag-users__popover').css("top", topCss + 'px');
      $('.tag-users__popover').css("left", leftCss + 'px');
      $('.tag-users__popover').show();
    },
    hideOtherUserTagged() {
      $('.tag-users__popover').hide();
    },
    getProfileLink(id) {
      return '/profile/' + id;
    },
  }
}
</script>

<style scoped>

</style>